
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/fansi-collections",
      function () {
        return require("private-next-pages/products/fansi-collections/index.tsx");
      }
    ]);
  